import { Component, OnInit, inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "ddd-update-terms-first-visit",
  templateUrl: "./update-terms-first-visit.component.html",
  styleUrls: ["./update-terms-first-visit.component.scss"],
  standalone: true,
  imports: []
})
export class UpdateTermsFirstVisitComponent implements OnInit {
  dialogRef = inject<MatDialogRef<UpdateTermsFirstVisitComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  public dialog: any;
  private PRIVACY_POLICY_URL =
    "https://carne-digital.atlassian.net/wiki/external/2723151873/MGE3MDJhNTc4NDc5NDZjM2E4OTI3MTQwNWFmNDZkMTA";
  private TERMS_AND_CONDITIONS_URL =
    "https://carne-digital.atlassian.net/wiki/external/2723151873/MGE3MDJhNTc4NDc5NDZjM2E4OTI3MTQwNWFmNDZkMTA";
  public agreeWithTerms: boolean = false;

  ngOnInit() {
    return;
  }
  public setStatus() {
    this.agreeWithTerms = !this.agreeWithTerms;
  }
}
